import { Component, OnInit } from '@angular/core';
import { RouterOutlet } from '@angular/router';

import { UnsavedChangesGuardComponent } from '@shared/components/src/lib/unsaved-changes-guard/unsaved-changes-guard.component';
import { StyledToastComponent } from '@shared/styled-components/src/lib/styled-toast/styled-toast.component';
import { getTablePreference } from '@shared/utils';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  imports: [RouterOutlet, StyledToastComponent, UnsavedChangesGuardComponent]
})
export class AppComponent implements OnInit {
  public ngOnInit(): void {
    this.applyTableTheme();
  }

  private applyTableTheme() {
    document.body.classList.remove('table-row-height-compact', 'table-row-height-normal', 'table-row-height-expanded');
    document.body.classList.add(`table-row-height-${getTablePreference()}`);
  }
}
